module.exports = "/_next/static/images/Hero-13dbf1635aab4b2ffe7220a2cbb424d2.webp";